export default "__VITE_ASSET__Sb4deytp__"